import { render, staticRenderFns } from "./UserEditTabTransferCustomers.vue?vue&type=template&id=2358fddd&"
import script from "./UserEditTabTransferCustomers.vue?vue&type=script&lang=js&"
export * from "./UserEditTabTransferCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports